import React, { useEffect, useState } from "react";
import { Modal, Button, List, Select, Spin, message } from "antd";
import { getEmpleados, getEmpleadosContacto, asignarEmpleadosContacto, eliminarEmpleadoContacto } from "../../servicios/clientes/empleadosContactoApi";

const { Option } = Select;

const ConfigurarEmpleadosContactoModal = ({ visible, onClose, cliente, sucursal }) => {
  const [empleados, setEmpleados] = useState([]);
  const [empleadosContacto, setEmpleadosContacto] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && cliente && sucursal) {
      setLoading(true);
      Promise.all([
        getEmpleados(sucursal),
        getEmpleadosContacto(sucursal, cliente)
      ]).then(([allEmpleados, contacto]) => {
        setEmpleados(allEmpleados);
        setEmpleadosContacto(contacto);
        setSelected(contacto.map(e => e.empleadoId));
        setLoading(false);
      });
    }
  }, [visible, cliente, sucursal]);

  const handleAsignar = async () => {
    setLoading(true);
    try {
      await asignarEmpleadosContacto(sucursal, cliente, empleados.filter(e => selected.includes(e.empleadoId)));
      message.success("Empleados de contacto actualizados");
      onClose(true);
    } catch (e) {
      message.error("Error al asignar empleados");
    }
    setLoading(false);
  };

  const handleEliminar = async (empleadoId) => {
    setLoading(true);
    try {
      await eliminarEmpleadoContacto(sucursal, cliente, empleadoId);
      setEmpleadosContacto(empleadosContacto.filter(e => e.empleadoId !== empleadoId));
      setSelected(selected.filter(id => id !== empleadoId));
      message.success("Empleado eliminado");
    } catch (e) {
      message.error("Error al eliminar empleado");
    }
    setLoading(false);
  };

  return (
    <Modal
      title={`Configurar empleados de contacto para ${cliente}`}
      visible={visible}
      onCancel={() => onClose(false)}
      onOk={handleAsignar}
      okText="Guardar"
      confirmLoading={loading}
    >
      {loading ? <Spin /> : <>
        <div style={{ marginBottom: 16 }}>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Selecciona empleados de contacto"
            value={selected}
            onChange={setSelected}
            optionLabelProp="label"
          >
            {empleados.map(emp => (
              <Option key={emp.empleadoId} value={emp.empleadoId} label={emp.nombre}>
                {emp.nombre} ({emp.correo})
              </Option>
            ))}
          </Select>
        </div>
        <List
          header={<b>Empleados de contacto actuales</b>}
          dataSource={empleadosContacto}
          renderItem={item => (
            <List.Item
              actions={[
                <Button danger size="small" onClick={() => handleEliminar(item.empleadoId)}>Eliminar</Button>
              ]}
            >
              {item.nombre} ({item.correo})
            </List.Item>
          )}
        />
      </>}
    </Modal>
  );
};

export default ConfigurarEmpleadosContactoModal;
